<template>
  <div>
    <div class="playerbg" v-if="showSearch">
      <div class="header" >
        <div class="title">
            <div class="han">运动员排行榜</div>
            <div class="eng">Athlete Rankings</div>
        </div>
        <div class="search">
            <input class="search-input" type="text" placeholder="请输入人名搜索" v-model="searchVal">
            <span class="search-btn" @click="search()">搜索</span>
            <img class="search-icon" src="../../../assets/search_icon.png" alt="" >
        </div>
        <div class="option">
            <a-icon type="environment" style="font-size:20px;"/>
            <a-select style="width:150px; margin-left:10px;" size="large" placeholder="请选择地区" @change="handleChange">
                <a-select-option v-for="(item, index) in address" :key="index" :value="item.value">
                    {{ item.label }}
                </a-select-option>
            </a-select>
        </div>
     </div>
    </div>
    <a-spin tip="加载中..." :spinning="spinning">
      <div class="page-column">
        <div class="content">
              <h4>共查询到{{ totalNum }}条数据</h4>
            <div class="table-header" >
                <div class="header-list" v-for="(header,index) in header" :key="index">
                    <div class="header-txt" v-if="header.type == 'txt'">{{header.value}}</div>
                    <div class="header-img" v-if="header.type == 'img'"><img :src="header.value" alt="" style="width:100%;height:100%"></div>
                </div>
            </div>
            <div class="table-body">
                <div class="body-list" @click="toDetail(player, index)" v-for="(player,index) in playerList" :key="index" :class="isOdd(index) ? '':'bg-F4F4F4' ">
                    <div class="index flx-1" >
                      <img class="rank-bg" :src="getRankBg(index)" alt="" v-if="handleIndex(index) < 4">
                      <span class="index-txt">{{handleIndex(index)}}</span>
                      </div>
                    <div class="player flx-1" >
                      <img class="player-head" :src="player.image" alt="">
                      <span>{{player.name}}</span>
                      </div>
                    <div class="agency flx-1" >{{player.unitName}}</div>
                    <div class="region flx-1" >{{player.areaName}}</div>
                    <div class="counts flx-1" >{{player.winNum}}/{{player.lostNum}}</div>
                    <div class="rate flx-1" >{{getWinRate(player.winNum,player.matchNum)}}</div>
                    <!-- <div class="gold flx-1" >{{player.gold}}</div>
                    <div class="sliver flx-1" >{{player.silver}}</div>
                    <div class="bronze flx-1" >{{player.bronze}}</div> -->
                    <div class="total-score flx-1" >{{player.score}}</div>
                </div>
                <div class="pages" v-if="playerList.length !==0">
                    <a-pagination v-model="current" :total="totalNum" :defaultPageSize="params.pageSize" show-less-items @change="onChange"/>
                </div>
            </div>
            <a-empty v-if="totalNum === 0" style="padding: 120px 0;"/>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import address from '@comm/utils/address'
export default {
  props: {
    showSearch: {
      type: Boolean,
      default:true
    }
  },
  data () {
    return {
      address: address,
      header: [
        {type: 'txt', value: '排名'},
        {type: 'txt', value: '运动员'},
        {type: 'txt', value: '机构'},
        {type: 'txt', value: '地区'},
        {type: 'txt', value: '胜/负场(PK)'},
        {type: 'txt', value: '胜率'},
        // {type: 'img', value: require('@comm/assets/jin.png')},
        // {type: 'img', value: require('@comm/assets/yin.png')},
        // {type: 'img', value: require('@comm/assets/tong.png')},
        {type: 'txt', value: '总积分'}
      ],
      rankBgList: [
        {index: 0, src: require('@comm/assets/gold_bg.png')},
        {index: 1, src: require('@comm/assets/sliver_bg.png')},
        {index: 2, src: require('@comm/assets/bronze_bg.png')}
      ],
      params: {
        programId: this.$route.query.programId,
        pageNum: 1,
        pageSize: 20,
        name: -1,
        province: -1,
        year: -1
      },
      searchVal: null,
      totalNum: 0,
      activeStatus: 0,
      current: 1,
      playerList: [],
      spinning: false
    }
  },
  created () {
    window.scrollTo(0, 0)
    this.loadData()
    this.handleAllOperation()
  },
  methods: {
    handleIndex (index) {
      // console.log('111', this.params.pageNum, (this.params.pageNum - 1) * this.params.pageSize + index + 1)
      return (this.params.pageNum - 1) * this.params.pageSize + index + 1
    },
    handleAllOperation () {
      let result = this.address.some(e => {
        if (e.value == '-1') {
          return true
        }
      })
      if (!result) {
        this.address.unshift({'value': '-1', 'label': '全部', 'children': []})
      }
    },
    onChange (page, pageSize) {
      // console.log('page,pageSize', page, pageSize)
      this.params.pageNum = page
      this.loadData()
    },
    getRankBg (index) {
      let src = ''
      this.rankBgList.forEach(rank => {
        if (rank.index == index) {
          src = rank.src
        }
      })
      return src
    },
    getWinRate (win, total) {
      if (total == 0) {
        return '暂无数据'
      } else {
        return (Number(win / total) * 100).toFixed(2) + '%'
      }
    },
    isOdd (index) {
      if ((index + 1) % 2 == 1) {
        return true
      } else {
        return false
      }
    },
    handleChange (value) {
      this.params.province = value
      this.loadData()
    },
    search () {
      this.params.pageNum = 1
      this.params.name = -1
      if (this.searchVal !== '' && this.searchVal !== undefined && this.searchVal !== null) {
        this.params.name = this.searchVal
      }
      this.loadData()
    },
    loadData (e) {
      this.spinning = true
      this.$api.match.getPlayRank(this.params).then(res => {
        this.spinning = false
        if (res.status == 0) {
          this.playerList = res.data
          this.totalNum = res.total
          // 将搜索关键词清空
          this.params.name = -1
          this.searchVal = ''
        }
      }).catch(err => {
        console.log('err', err)
      })
    },
    toDetail (player, index) {
      this.$router.push('/PlayerDetail?programId=' + this.$route.query.programId + '&detail=' + encodeURI(JSON.stringify(player)) + '&rank=' + this.handleIndex(index))
    }
  }
}
</script>
<style lang="scss" scoped>
.playerbg{
  height: 200px;
  padding-top: 40px;
  background-image: url('../../../assets/weapon/playertopbg.jpg');
}
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  margin: 20px auto;
  min-height: 400px;
  // position: relative;
  // background-color: green;
}
.header{
  width: 1200px;
  padding: 30px 0 20px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: rgb(236, 236, 236);
  border-radius: 10px;
  padding: 40px;
}
.search{
  // background-color: green;
  position: relative;
}
.search-input{
  width: 330px;
  padding-left: 50px;
  border: 0px;
  height: 50px;
  outline: none;
  border-bottom: 1px solid #b3b3b3;
  font-size: 13px;
}
.search-icon{
  width: 17px;
  position:absolute;
  left: 15px;
  top: 15px;
}
.body{
  width: 100%;
  padding: 10px calc(50% - 600px);
  background-color: #EEE;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.han{
  font-size: 20px;
  margin-right: 10px;
  font-weight: bold ;
}
.eng{
  font-size: 20px;
}
.title{
 flex: 1;
  height: 31px;
  color: #333;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  // margin-bottom: 47px;
}
.option{
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.content{
    width: 1200px;
    margin: 0 auto;
    box-shadow: 0 8px 12px #ebedf0;
    // position: relative;
}
.table-header{
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #b01f23;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px 10px 0px 0px;
}
.table-body{
    width: 100%;
    line-height: 50px;
    // background: #B01F24;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}
.header-list{
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.flx-1{
    flex: 1;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: row;
    overflow: hidden;
    white-space: nowrap;
}
.body-list{
    width: 100%;
    // padding: 8px 0;
    // box-sizing: content-box;
    // flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
}
.header-txt{
    color: #fff;
    font-size: 15px;
    font-weight: bold;
}
.header-img{
    width: 30px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.bg-F4F4F4{
  background-color: #F4F4F4;
}
.player-head{
  width: 44px;
  height: 44px;
  border-radius: 8px;
  margin-right: 8px;
}
.player{
  // display: flex;
  // flex-direction: row;
  justify-content: flex-start !important;
}
.index{
  position: relative;
  height: 70px;
  display: flex;
  align-items: center;
}
.rank-bg{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.index-txt{
  z-index: 2;
}
.pages{
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
  overflow: hidden;
  // background-color: #EEE;
  display: flex;
  justify-content: center;
  // position: relative;
  // bottom: 0;
}
.search-btn{
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 30px;
    padding-right: 30px;
    text-align: center;
    background: #b01f23;
    color:white;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/AthleteRanking.vue